(ns app.front.query.process
  (:require [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::check-signals-permitted
  (fn [{:keys [db]} [_ workspaces->phase-entity-types->signals]]
    {:db           (assoc-in db [::state :loading?] true)
     :comm/command {:command          :process/check-signals-permitted
                    :method           :post
                    :data             {:signals workspaces->phase-entity-types->signals}
                    :on-success       [::check-signals-permitted.success]
                    :finally-dispatch [::check-signals-permitted.done]}}))

(rf/reg-event-db ::check-signals-permitted.success
  (fn [db [_  status workspaces->phase-entity-types->signals->forbidden-guards]]
    (if (= 200 status)
      (assoc-in db [::state :signal-guards] workspaces->phase-entity-types->signals->forbidden-guards)
      db)))

(rf/reg-event-db ::check-signals-permitted.done
  (fn [db _]
    (assoc-in db [::state :loading?] false)))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::loading?
  :<- [::state]
  :-> :loading?)

(defn get-allowed-signals [phase-type phase-type->signals->forbidden-guards]
  (->> (get phase-type->signals->forbidden-guards phase-type)
       (keep (fn [[signal forbidden-by-guards]]
               (when (empty? forbidden-by-guards)
                 signal)))))

(rf/reg-sub ::allowed-signals
  :<- [::state]
  (fn [{:keys [signal-guards]} [_ phase-type workspace-ids]]
    (-> signal-guards
        (select-keys workspace-ids)
        (update-vals (partial get-allowed-signals phase-type)))))

(rf/reg-sub ::signal-allowed?
  :<- [::state]
  (fn [{:keys [signal-guards]} [_ phase-type workspace-id signal]]
    (= (get-in signal-guards [workspace-id phase-type signal]) #{})))
